<em-auth-wrapper>
  <form
    [formGroup]="resetPasswordForm"
    (ngSubmit)="onSubmit()"
    autocomplete="off"
    >
    <mat-form-field appearance="outline" class="em-form-field">
      <mat-label>Password</mat-label>
      <input
        matInput
        type="password"
        id="password"
        placeholder="********"
        formControlName="password"
        />
      @if (resetPasswordForm.get('password')?.hasError('required')) {
        <mat-error emError="required" />
      }
      @if (resetPasswordForm.get('password')?.hasError('minlength')) {
        <mat-error
          emError="minlength"
          [minlength]="resetPasswordForm.get('password')?.errors?.['minlength']?.requiredLength"
          />
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="em-form-field">
      <mat-label>Confirm password</mat-label>
      <input
        matInput
        type="password"
        id="confirm_password"
        placeholder="********"
        formControlName="confirm_password"
        />
      @if (resetPasswordForm.get('confirm_password')?.hasError('required')) {
        <mat-error emError="required" />
      }
      @if (resetPasswordForm.get('confirm_password')?.hasError('notMatch')) {
        <mat-error>
          Passwords do not match.
        </mat-error>
      }
    </mat-form-field>

    <button
      emsysButton
      appearance="primary"
      [showLoader]="loading$|async"
      class="w-full mt-1"
      >
      Reset password
      <svg class="w-6 h-6 ml-auto">
        <use xlink:href="assets/icons/symbols.svg#arrow-right"></use>
      </svg>
    </button>
  </form>

  <ng-template teleport="greet">
    <div class="flex flex-col min-h-full">
      <h1 class="text-4xl font-bold">
        Sales Portal
      </h1>

      <div class="flex items-center font-bold text-xl">
        <div class="h-[2px] w-5 bg-blue-50/25 mr-2.5"></div>
        Reset password
      </div>
    </div>
  </ng-template>
</em-auth-wrapper>
